
export const typeData = [
    { name: "Valeur d'état (moyenne)", id: "1527" },
    { name: "Valeur binaire (moyenne)", id: "1528"},
    { name: "Défaut (moyenne)", id: "1529"},
    { name: "Valeur analogique (moyenne)", id: "1530"},
    { name: "Index", id: "1531"},
    { name: "Valeur analogique (somme)", id: "1532"},
]

